
const DEFAULT_STEP = [
  "app_launch",
];

function capitalize(text: string) {
  const words = text?.split(" ");
  for (let i = 0;i < words?.length;i++) {
    words[i] = words?.[i]?.charAt(0)?.toUpperCase() + words?.[i]?.slice(1);
  }
  return words?.join(" ");
}

export const bindCnEnNameMap = (list = [] as any, codeKey = '', enKey = '', chKey = '', isCapitalize = false) => {
  const map = {};
  list?.forEach((item: string) => {
    if (typeof item === 'string') {
      map[item] = item;
    } else {
      map[item[codeKey]] = { cn: item[chKey], en: isCapitalize ? capitalize(item[enKey]) : item[enKey] };
    }
  });
  return map;
};

const getSelectorMap = (selectorList: any) => {
  const {
    channel_list,
    os_list,
    zone_list,
    country_list,
    area_list,
    network_list,
    lang_list,
    app_version_list,
    memory_list,
    store_channel_list,
    stage_list,
  } = selectorList;

  const countryList = (() => {
    if (country_list && Array.isArray(country_list)) return country_list;
    let result: any[] = [];
    area_list?.forEach((item: { country_set: any; }) => {
      if (item.country_set && Array.isArray(item.country_set)) {
        result = result.concat(item.country_set);
      }
    });
    return result;
  })();

  const nameCnMap = {
    channel: bindCnEnNameMap(channel_list, 'channel_id', 'channel_name_en', 'channel_name_ch'),
    system: bindCnEnNameMap(os_list, 'os_id', 'os_name_en', 'os_name_ch'),
    zone: bindCnEnNameMap(zone_list, 'zone_code', 'zone_name_en', 'zone_name_ch'),
    country: bindCnEnNameMap(countryList, 'country_code', 'country_name_en', 'country_name_ch'),
    region: bindCnEnNameMap(area_list, 'area_code', 'area_name_en', 'area_name_ch'),
    language: bindCnEnNameMap(lang_list, 'lang_code', 'lang_name_en', 'lang_name_ch'),
    network: bindCnEnNameMap(network_list),
    network_type: bindCnEnNameMap(network_list, 'network_id', 'network_name_en', 'network_name_ch'),
    app_version: bindCnEnNameMap(app_version_list, 'app_id', 'app_name_en', 'app_name_ch'),
    memory: bindCnEnNameMap(memory_list, 'memory_id', 'memory_name_en', 'memory_name_ch'),
    store_channel: bindCnEnNameMap(store_channel_list, 'store_channel_id', 'store_channel_name_en', 'store_channel_name_ch'),
    stage: bindCnEnNameMap(stage_list, 'stage_id', 'stage_name_en', 'stage_name_ch', true),
  };

  return { nameCnMap };
};


const getFunnelText = (type: any, code: any, gameCode = 'test', locale: any, selectorList?: any) => {
  const map: any = getSelectorMap(selectorList)?.nameCnMap;
  if (!gameCode || !map) {
    return code;
  }
  if (locale === 'en-US') {
    return map?.[type]?.[code]?.en || code;
  } 
  return map?.[type]?.[code]?.cn || map?.[type]?.[code]?.en || code;
  
};

export {
  DEFAULT_STEP,
  getFunnelText,
};